var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading-page"},[_c('v-icon',{attrs:{"large":""}},[_vm._v("fal fa-spinner fa-spin")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }